/**
 * Created by Nico on 14.07.2016.
 */
define('services/TaxService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('TaxService', ['$injector', TaxService]);
});

function TaxService($injector) {
	crudInstance = $injector.instantiate(CrudService);
	crudInstance.setType('Tax');

	angular.extend(this, crudInstance);

	return this;
}
;
